import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "./navbar";
import Footer from "./footer";
import "../index.css";

const AuditLogs = () => {
  const [auditLogs, setAuditLogs] = useState([]);
  const [filteredAuditLogs, setFilteredAuditLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15);
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
    const token = window.sessionStorage.getItem("jwtToken");

  useEffect(() => {
    const fetchAuditLogs = async () => {
      try {
        const response = await fetch(`${BASE_URL}/fetchAuditLogs`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          }
        });

        if (!response.ok) {
          throw new Error("Failed to fetch audit logs");
        }
        const data = await response.json();
        setAuditLogs(data);
        setFilteredAuditLogs(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAuditLogs();
  }, [BASE_URL]);

  useEffect(() => {
    if (searchTerm === "") {
      setFilteredAuditLogs(auditLogs);
    } else {
      const filtered = auditLogs.filter((log) =>
        log.stock_name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredAuditLogs(filtered);
    }
  }, [searchTerm, auditLogs]);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(1);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentLogs = filteredAuditLogs.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredAuditLogs.length / itemsPerPage);

  const renderPaginationButtons = () => {
    const buttons = [];
    const maxButtons = 5;
    const startPage = Math.max(1, currentPage - Math.floor(maxButtons / 2));
    const endPage = Math.min(totalPages, startPage + maxButtons - 1);

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <li className={`page-item ${currentPage === i ? "active" : ""}`} key={i}>
          <button className="page-link" onClick={() => handlePageChange(i)}>
            {i}
          </button>
        </li>
      );
    }

    if (startPage > 1) {
      buttons.unshift(
        <li className="page-item" key="start-ellipsis">
          <span className="page-link">...</span>
        </li>
      );
    }
    if (endPage < totalPages) {
      buttons.push(
        <li className="page-item" key="end-ellipsis">
          <span className="page-link">...</span>
        </li>
      );
    }

    return buttons;
  };


  return (
    <>
      <Navbar />
      <div className="main-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between mb-3">
            <button className="btn btn-primary" onClick={() => navigate(-1)} style={{ marginBottom: '10px', marginTop: '10px' }}>
              Back
            </button>
            <h4 className="fw-bold">Audit Logs</h4>
            <h4></h4>
          </div>

          <div className="mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Search by Stock Name"
              value={searchTerm}
              style={{ width: '15%' }}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Stock Name</th>
                  <th>Criteria</th>
                  <th>Criteria2</th>
                  <th>Data Type</th>
                  <th>Executed On</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
              {currentLogs.length > 0 ? (
                currentLogs.map((log, index) => (
                  <tr key={log.id}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>{log.stock_name}</td>
                    <td>{log.criteria}</td>
                    <td>{log.criteria2}</td>
                    <td>{log.data_type}</td>
                    <td>{log.executedOn}</td>
                    <td>{log.status}</td>
                  </tr>
                ))
                 ) : (
                  <tr>
                    <td colSpan="7">No Audit Logs Found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {totalPages > 1 && (
            <nav className="d-flex justify-content-center mt-3">
              <ul className="pagination">
                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </button>
                </li>
                {renderPaginationButtons()}
                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>
                </li>
              </ul>
              <div className="d-flex justify-content-between align-items-center mt-2">
                <span>Show </span>
                <select
                  value={itemsPerPage}
                  onChange={handleItemsPerPageChange}
                  className="form-select d-inline-block w-auto mx-2"
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={15}>15</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </select>
                <span> entries</span>
              </div>
            </nav>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AuditLogs;
